<template>
  <div>
    <div class="bg-black flex justify-end">
      <NuxtImg
        provider="cloudflare"
        src="/37/f8/5f/c899afbeb1753d0d565ca7132004a7d8ac/Retoure_Bild_90-0.png"
        alt="Retoure"
        title="Retoure_Bild"
        fit="contain"
      />
    </div>
    <div class="container mx-auto py-10">
      <h1 class="text-xl py-4">Retouren & Vertrag Widerrufen</h1>
      <div
        ref="info"
        class="relative"
      >
        <div
          v-if="submitting"
          class="absolute left-0 right-0 top-0 bottom-0 cursor-wait z-10"
        >
          <div class="bg-white h-full w-full opacity-50 absolute" />
          <BasicLoader
            :rows="1"
            :columns="1"
            height="100%"
          />
        </div>

        <div
          v-if="sendReturnMailError"
          class="text-error-dark border-error-dark border-dashed border p-4 text-center bg-error-light mb-4 text-sm"
        >
          <p>Es gab leider einen Fehler. Bitte versuchen Sie es erneut.</p>
        </div>

        <div
          v-if="sendReturnMailSuccess"
          class="text-error-dark border-error-dark border-dashed border p-4 text-center bg-green-100 mb-4 text-sm"
        >
          <p>Wir haben ihre Anfrage erhalten und werden Sie zeitnah kontaktieren.</p>
        </div>

        <div
          v-if="error"
          class="text-error-dark border-error-dark border-dashed border p-4 text-center bg-error-light mb-4 text-sm"
        >
          <p>
            <template v-if="loginError">Wir konnten ihre Bestellung finden. Da ihre </template>
            <template v-else>Wir konnten keine Gast-Bestellung finden. Falls die </template>
            Bestellung mit einem Kundenaccount angelegt wurde, kann diese
            <span class="underline">
              <a
                class="text-primary"
                href="/shop/mein-expert/bestellungen"
                >hier</a
              >
            </span>
            gefunden werden.
            <template v-if="loginError"
              ><br >Wir haben Ihnen eine E-Mail mit einem Login-Link gesendet. Klicken Sie einfach auf den Link in der
              E-Mail, um sich anzumelden und die Retoure für diese Bestellung durchzuführen.</template
            >
            <br ><br >
            Sollten Sie weiterhin Probleme haben, kontaktieren Sie uns gerne schriftlich (<a
              class="text-primary underline"
              href="mailto:kundenservice@expert-commerce.de"
              >kundenservice@expert-commerce.de</a
            >) oder telefonisch (
            <a
              class="text-paragraph underline"
              :href="'tel:020380481842'"
              >020380481842</a
            >
            ) und wir helfen Ihnen gerne persönlich.
          </p>
        </div>
        <div class="text-sm">
          <p>
            Sie m&ouml;chten ein bei Expert gekauftes Produkt zur&uuml;ckgeben oder Ihre Bestellung widerrufen? Sie
            können einzelne Artikel ausw&auml;hlen oder den Widerruf für die gesamte Bestellung erkl&auml;ren. Sie
            können Ihre Retoure entweder an unser Logistikzentrum zur&uuml;cksenden oder direkt bei Ihrem betreuenden
            expert Fachmarkt vor Ort retournieren. Informationen zu Fristen, R&uuml;cksendekosten und
            R&uuml;ckgabezustand finden Sie in unseren AGB im Abschnitt Widerrufsbelehrung.
            <template v-if="!isAppUser">
              <br >
              <br >
              Wenn Sie Ihre Bestellung &uuml;ber Ihr Kundenkonto get&auml;tigt haben, loggen Sie sich bitte unter
              "<span class="underline"
                ><a
                  class="text-primary"
                  href="/shop/mein-expert/bestellungen"
                  >Mein Konto</a
                ></span
              >" ein und w&auml;hlen Sie die Bestellung unter "Meine Bestellung" aus. Sollten Sie als Gast bestellt
              haben, f&uuml;llen Sie bitte die untenstehenden Felder aus.
            </template>
          </p>
        </div>
        <div class="py-2">
          <div class="text-right text-paragraph-light py-1 text-xs">*Pflichtfeld</div>
          <form
            ref="form"
            class="flex flex-col gap-3"
            @submit.prevent="handleSubmit"
          >
            <input
              v-model="email"
              type="email"
              aria-label="E-Mail"
              inputmode="email"
              autocomplete="email"
              class="w-full inp"
              placeholder="E-Mail-Adresse*"
              required
              title="Bitte verwenden Sie die E-Mail-Adresse, die Sie bei der Bestellung angegeben haben."
              @input="sanitizeEmail"
            >
            <input
              v-model="orderId"
              type="text"
              aria-label="Bestellnummer"
              class="w-full inp"
              placeholder="Bestellnummer* z.B.: MA123456789"
              required
              :minlength="pConfig.isProduction ? 11 : 10"
              maxlength="11"
              autocomplete="off"
              :pattern="pConfig.isProduction ? 'MA\\d{9}' : 'MA?\\d{9}'"
              inputmode="text"
              title="Bitte geben Sie die Bestellnummer im Format MA123456789 ein (MA + 9 Ziffern)."
              @input="sanitizeOrderId"
            >
            <div>
              <basic-turnstile @success="turnstileSuccessCallback"/>
            </div>
            <button
              v-if="isAppUser"
              type="submit"
              name="return"
              :disabled="submitting"
              class="btn-primary px-6 font-bold py-4 text-sm"
            >
              Widerruf bestätigen
            </button>
            <div v-else>
              <button
                type="submit"
                name="search"
                :disabled="submitting"
                class="btn-primary px-6 font-bold py-4 text-sm"
              >
                Bestellung finden
              </button>
              <div class="border border-red-200 bg-red-50 p-4 rounded text-sm mt-8">
                <p class="font-bold mb-2">Gesamte Bestellung widerrufen</p>
                <p class="mb-3">
                  Wenn Sie auf „Widerruf bestätigen“ klicken, widerrufen Sie den Kaufvertrag für die gesamte
                  Bestellung. Dadurch werden alle Artikel dieser Bestellung widerrufen.
                </p>
                <button
                  type="submit"
                  name="return"
                  :disabled="submitting"
                  class="btn-primary px-6 font-bold py-4 text-sm"
                >
                  Widerruf bestätigen
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { withCdn } from '~~/shared/statics';

const route = useRoute();
const router = useRouter();
const pConfig = useRuntimeConfig().public;
const appConfig = useAppConfig();
const isAppUser = computed(() => appConfig.isAppUser);

const image = useCurrentStoreLogo(true);

const missingCaptcha = ref(false);
const captcha = ref<{ reset: () => void } | null>(null);
const captchaToken = ref();

const email = ref('');
const orderId = ref('');
const error = ref(false);
const loginError = ref(false);
const sendReturnMailError = ref(false);
const sendReturnMailSuccess = ref(false);
const form = ref();
const info = ref();
const submitting = ref(false);

useHead({
  title: 'Retoure Suchen',
});

onMounted(() => {
  if (typeof route.query.email === 'string') {
    email.value = route.query.email;
    sanitizeEmail();
  }

  if (typeof route.query.orderId === 'string') {
    orderId.value = route.query.orderId;
    sanitizeOrderId();
  }
});

const sanitizeEmail = () => {
  email.value = email.value
    .replace(/[\s\u00A0]+/g, '')
    .replace(/[,;]/g, '')
    .toLowerCase();
};

const sanitizeOrderId = () => {
  orderId.value = orderId.value
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, '')
    .slice(0, 11);
};

const turnstileSuccessCallback = (token: string): void => {
  captchaToken.value = token;
};

async function handleSubmit(event: SubmitEvent) {
  submitting.value = true;
  const submitter = (event.submitter ?? null) as HTMLButtonElement | null;
  sanitizeEmail();
  sanitizeOrderId();
  if (!captchaToken.value) {
    missingCaptcha.value = true;
    return;
  }
  missingCaptcha.value = false;

  switch (submitter?.name) {
    case 'search':
      await anonymousRma();
      break;
    case 'return':
    default:
      await sendReturnEmail();
      break;
  }
  submitting.value = false;
}

const sendReturnEmail = async (): Promise<void> => {
  sendReturnMailError.value = false;
  sendReturnMailSuccess.value = false;

  const { error } = await useFetch('/api/contact/cancelOrder', {
    method: 'POST',
    body: {
      id: orderId.value,
      email: email.value,
      logo: withCdn(image.value),
      link: `https://www.expert.de${appConfig.homelink}`
    },
  });

  if (error.value) {
    sendReturnMailError.value = true;
    captcha.value?.reset();
  } else {
    sendReturnMailSuccess.value = true;
  }
  info.value.scrollIntoView();
};

const anonymousRma = async (): Promise<void> => {
  error.value = false;
  loginError.value = false;

  let data = null;
  try {
    data = await startAnonymousRma(email.value, orderId.value, captchaToken.value);

    if (data && data.orderId && data.loginPerformed) {
      router.push({ path: '/shop/mein-expert/retoure', query: { orderId: data.orderId } });
    } else {
      if (data && !data.loginPerformed) {
        error.value = true;
        loginError.value = true;
        captcha.value?.reset();
      } else {
        error.value = true;
        captcha.value?.reset();
      }
      info.value.scrollIntoView();
    }
  } catch {
    error.value = true;
    captcha.value?.reset();
    info.value.scrollIntoView();
  }
};
</script>

<style>
.cf-turnstile > div {
  margin-bottom: -6px;
}
</style>
